// jQuery(".accordion_lista .accordion_lista__title").on("click", function() {
//   console.log('sisiis');
//   const content = jQuery(this)
//     .closest(".accordion_lista__item");

//   const className = "accordion_lista__item--open";

//   if (content.hasClass(className)) {
//     content
//       .removeClass(className)
//       .find(".accordion_lista__content").slideUp();
//   } else {
//     content
//       .addClass(className)
//       .find(".accordion_lista__content").slideDown();
//   }
// });

jQuery(document).ready(function($) {
    let animationInProgress = false;
    
    $(".accordion_lista .accordion_lista__title").on("mouseenter", function() {
        if (animationInProgress) return;
        
        const $currentItem = $(this).closest(".accordion_lista__item");
        const $currentContent = $currentItem.find(".accordion_lista__content");
        const className = "accordion_lista__item--open";
        
        // Se l'elemento è già aperto, non fare nulla
        if ($currentItem.hasClass(className)) return;
        
        animationInProgress = true;
        
        // Chiudi tutti gli altri accordion
        $(".accordion_lista__item").not($currentItem)
            .removeClass(className)
            .find(".accordion_lista__content")
            .slideUp(700);
            
        // Apri l'accordion corrente
        $currentItem.addClass(className);
        $currentContent.slideDown(700, function() {
            animationInProgress = false;
        });
    });
});
